export var globalJson: any = {
  prod_company_id: null,
  dev_company_id: null,

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  about_us_para:
    "At AKM Rentals, we offer reliable, affordable, and high-quality car rental services. With a diverse fleet and seamless booking, we make every journey hassle-free. Drive with confidence—choose AKM Rentals!",

  //social links
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",

  //contact
  address: "N/A",
  operating_time: "",
  addressLink: "N/A",
  phone: "N/A",
  email: "N/A",
  company_name: "Car Rental",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
